import React from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { FormSection, OptionCard } from '@/components';
import { IBulletinFormValues, BulletinFormFieldHandler } from '@/types/admin/bulletins';
import { ADMIN_COLORS } from '@/constants/admin';

interface UrgencyOptionsSectionProps {
  formData: IBulletinFormValues;
  onFieldChange: BulletinFormFieldHandler;
}

export const UrgencyOptionsSection: React.FC<UrgencyOptionsSectionProps> = ({
  formData,
  onFieldChange,
}) => {
  return (
    <FormSection 
      title="Urgency Features"
      subtitle="Optional settings to help bring more attention to the bulletin"
    >
      <View style={styles.container}>
        <View style={styles.optionsGrid}>
          <View style={styles.leftColumn}>
            <OptionCard
              title="Send Email"
              subtitle="Residents will receive email in addition to push notifications"
              value={formData.sendEmail}
              onPress={() => onFieldChange('sendEmail', !formData.sendEmail)}
              type="checkbox"
            />
            
            <OptionCard
              title="Highlight with Border"
              subtitle="Use a purple border to make the bulletin stand out visually"
              value={formData.highlight}
              onPress={() => onFieldChange('highlight', !formData.highlight)}
              type="checkbox"
            />
          </View>
          
          <View style={styles.rightColumn}>
            <OptionCard
              title="Pin to Homepage"
              subtitle="Place a bulletin shortcut in the residents' most visible spot"
              value={formData.pinHomepage}
              onPress={() => onFieldChange('pinHomepage', !formData.pinHomepage)}
              type="checkbox"
            />
            
            {formData.pinHomepage && (
              <View style={styles.warningContainer}>
                <View style={styles.warningIcon}>
                  <Text style={styles.warningIconText}>!</Text>
                </View>
                <Text style={styles.warningText}>
                  This selection will override any other pinned bulletins.
                </Text>
              </View>
            )}
          </View>
        </View>
      </View>
    </FormSection>
  );
};

const styles = StyleSheet.create({
  container: {
    // No additional styles needed
  },
  optionsGrid: {
    flexDirection: 'row',
    gap: 16,
    alignItems: 'flex-start', // Ensure cards align at the top
  },
  leftColumn: {
    flex: 1,
  },
  rightColumn: {
    flex: 1,
  },
  warningContainer: {
    backgroundColor: ADMIN_COLORS.WARNING + '20',
    borderRadius: 8,
    padding: 12,
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginTop: 8,
  },
  warningIcon: {
    width: 20,
    height: 20,
    borderRadius: 10,
    backgroundColor: ADMIN_COLORS.WARNING,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 8,
    marginTop: 1,
  },
  warningIconText: {
    color: '#FFFFFF',
    fontSize: 12,
    fontWeight: '600',
  },
  warningText: {
    flex: 1,
    fontSize: 12,
    color: ADMIN_COLORS.WARNING,
    lineHeight: 16,
  },
});
